

﻿


// This file was automatically generated by the PetaPoco T4 Template
// Do not make changes directly to this file - edit the template instead
// 
// The following connection settings were used to generate this file
// 
//     Connection String Name: ``
//     Provider:               `System.Data.SqlClient`
//     Connection String:      `server=localhost;Integrated Security=True;database=TooBig4Car;`
//     Schema:                 `dbo`
//     Include Views:          `False`

					
				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { ContentAndStatus } from '../../Models/OtherClasses';

@Injectable()
export class ShipmentBOLService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('ShipmentBOL');
	}

	loadPending(): Observable<TooBig4Car.Logic.ShipmentBOL[]> {
		return this.myBaseService.loadAll(this.url + '/Pending');
	}
	changeCustomer(searchObj: TooBig4Car.Logic.ShipmentBOLCustomerChangeVM): Observable<TooBig4Car.Logic.ShipmentBOL> {
		return this.myBaseService.post(searchObj, this.url + '/ChangeCustomer', true);
	}
	save(tempItem: TooBig4Car.Logic.ShipmentBOL) : Observable<ContentAndStatus<TooBig4Car.Logic.ShipmentBOL>> {
		return this.myBaseService.postWithStatusCode(tempItem, this.url, true);
	}
	savePending(tempItem: TooBig4Car.Logic.ShipmentBOL) : Observable<ContentAndStatus<TooBig4Car.Logic.ShipmentBOL>> {
		return this.myBaseService.postWithStatusCode(tempItem, this.url + '/Pending', true);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.ShipmentBOL> {
		return this.myBaseService.getEdit(id, this.url);
	}
	getEditPending(id: System.Guid): Observable<TooBig4Car.Logic.ShipmentBOL> {
		return this.myBaseService.getEdit(id, this.url + '/Pending');
	}
	get(id: System.Guid) : Observable<TooBig4Car.Logic.ShipmentBOL>{
		return this.myBaseService.get(id, this.url);
	}
	search(searchObj: TooBig4Car.Logic.SearchVM) : Observable<TooBig4Car.Logic.ShipmentBOL[]>{
		return this.myBaseService.post(searchObj, this.url + '/Search', false);
	}
	searchReceivedPieceCount(searchObj: TooBig4Car.Logic.SearchVM) : Observable<number>{
		return this.myBaseService.post(searchObj, this.url + '/Search/ReceivedPieceCount', false);
	}

	getSplit(id: System.Guid): Observable<TooBig4Car.Logic.SplitShipmentVM> {
		return this.myBaseService.get(id, this.url +'/Split');
	}
	saveSplit(tempItem: TooBig4Car.Logic.SplitShipmentVM): Observable<ContentAndStatus<TooBig4Car.Logic.SplitShipmentVM>> {
		return this.myBaseService.postWithStatusCode(tempItem, this.url + '/Split', true);
	}

	getArrive(id: System.Guid): Observable<TooBig4Car.Logic.ShipmentArrivalVM> {
		return this.myBaseService.get(id, this.url + '/Arrive');
	}
	saveArrive(tempItem: TooBig4Car.Logic.ShipmentArrivalVM): Observable<TooBig4Car.Logic.ShipmentArrivalVM>{
		return this.myBaseService.post(tempItem, this.url + '/Arrive', true);
	}
	savePendingTypes(tempItem: TooBig4Car.Logic.ShipmentPendingTypesVM): Observable<TooBig4Car.Logic.ShipmentBOL> {
		return this.myBaseService.post(tempItem, this.url + '/PendingTypes', true);
	}
}
				
